import CardWithRoles from "components/card/CardWithRoles";
import adminConsoleImage from "./admin-console.svg";

export default function AdminConsoleCard() {
  return (
    <CardWithRoles
      name="Admin Console"
      image={adminConsoleImage}
      description="Access management for tenant administration."
      targetRoles={["Admin"]}
      link={`/admin-console`}
      testid="admin-console"
    />
  );
}
